import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";
import { getAuth, GoogleAuthProvider } from 'firebase/auth'
const firebaseConfig = {
  apiKey: "AIzaSyCVrAHOJ5izBuTlDvtGgxEDJp3zeDrwpgg",
  authDomain: "roadmap-84528.firebaseapp.com",
  projectId: "roadmap-84528",
  storageBucket: "roadmap-84528.appspot.com",
  messagingSenderId: "715862187657",
  appId: "1:715862187657:web:182dedf67e85abab7ff058"
};
export const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app);
export const auth = getAuth(app);
export const provider = new GoogleAuthProvider();
